"use strict";

import $ from 'jquery';

$(() => {
    const $document = $(document),
      $element = $('nav.main-nav'),
      className = 'has-scrolled';

    $document.scroll(function() {
        $element.toggleClass(className, $document.scrollTop() > 0);
    });

    $('.main-nav-toggle, .nav-header .nav-toggle').on('click', (e) => {
        e.preventDefault();
        $('.mobile-menu').toggleClass('expanded');
    });

    $('.mobile-menu .dropdown-menu a').on('click', function () {
        $('.mobile-menu').toggleClass('expanded');
    });

    $('.mobile-menu').on('click', (e) => {
        const target = $(e.target);
        if (!target.is('.mobile-menu-list')
            && target.closest('.mobile-menu-list').length === 0) {
            $('.mobile-menu').removeClass('expanded');
        }
    });
});
